import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const WebDevServes = ({ features, cardsPerRow = 4, hasHeading }) => {
    const rows = [];
    for (let i = 0; i < features.length; i += cardsPerRow) {
        rows.push(features.slice(i, i + cardsPerRow));
    }

    return (
        <div style={{ backgroundColor: "#f8f9fa" }}>
            <Container className="mb-5 py-5">
                {hasHeading ? (
                    <>
                        <h2 className="fw-bold my-2">{hasHeading}</h2>
                        <div className="mx-auto mb-3" style={{
                            width: '60px',
                            height: '4px',
                            backgroundColor: '#3bc9f5',
                            borderRadius: '2px'
                        }}></div>
                        <p className='fw-bold text-secondary mb-5'>
                            We've worked with a variety of sectors, solving their complicated problems, assisting them in gaining more business, and eventually achieving their business objectives.
                        </p>
                    </>
                ) : (
                    <>
                        <h2 className="fw-bold my-2">Main Features</h2>
                        <div className="mx-auto mb-5" style={{
                            width: '60px',
                            height: '4px',
                            backgroundColor: '#3bc9f5',
                            borderRadius: '2px'
                        }}></div>
                    </>
                )}

                {rows.map((row, rowIndex) => (
                    <Row key={rowIndex} >
                        {row.map((feature, index) => (
                            <Col className='mb-3' key={index} md={12 / cardsPerRow}>
                                <Card className="h-100 shadow-sm mainfeature-card d-flex flex-row align-items-center p-3">
                                    <div className="feature-icon me-3">
                                        {feature.icon ? (
                                            <div className="icon-wrapper">
                                                <img
                                                    src={feature.icon}
                                                    alt={feature.title}
                                                    className="feature-img"
                                                />
                                            </div>
                                        ) : (
                                            <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center default-icon"
                                                style={{ width: '60px', height: '60px', fontSize: '20px' }}>
                                                {index + 1 + (rowIndex * cardsPerRow)}
                                            </div>
                                        )}
                                    </div>
                                    <div>
                                        <Card.Title className="h6 mb-0">{feature.title}</Card.Title>
                                    </div>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                ))}

                <style>{`
                    .mainfeature-card {
                        transition: all 0.3s ease;
                        border: none;
                        border-radius: 12px !important;
                        min-height: 100px;
                    }
                    .mainfeature-card:hover {
                        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1) !important;
                    }
                    .icon-wrapper {
                        width: 80px;
                        height: 80px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: 50%;
                        background-color: #f1f1f1;
                        transition: background-color 0.3s ease;
                    }
                    .mainfeature-card:hover .icon-wrapper {
                        background-color: #04b4e4;
                    }
                    .feature-img {
                        width: 70px;
                        height: 70px;
                        object-fit: contain;
                    }
                    .default-icon {
                        width: 60px;
                        height: 60px;
                        font-size: 20px;
                        transition: background-color 0.3s ease;
                    }
                    .mainfeature-card:hover .default-icon {
                        background-color: #04b4e4 !important;
                    }

                    @media (max-width: 768px) {
                        .mainfeature-card {
                            flex-direction: column;
                            text-align: center;
                            min-height: 140px;
                        }
                        .feature-icon {
                            margin-right: 0 !important;
                            margin-bottom: 10px;
                        }
                    }
                `}</style>
            </Container>
        </div>
    );
};

export default WebDevServes;
